import type * as THREE from 'three';

// Upload only the live part of a pooled buffer: re-sending the whole capacity every frame wastes phone memory bandwidth.
// three clears the ranges after each upload, so callers mark them again every frame the data changes.
export function uploadFirst(attr: THREE.BufferAttribute | null | undefined, count: number): void {
  if (!attr || count <= 0) return;
  attr.addUpdateRange(0, count * attr.itemSize);
  attr.needsUpdate = true;
}

// An element's size kept current by a ResizeObserver: reading clientWidth every frame forces a layout after each HUD change.
export function trackSize(el: HTMLElement): { width: number; height: number; dispose: () => void } {
  const ro = new ResizeObserver(([entry]) => {
    size.width = entry.contentRect.width;
    size.height = entry.contentRect.height;
  });
  const size = { width: el.clientWidth, height: el.clientHeight, dispose: () => ro.disconnect() };
  ro.observe(el);
  return size;
}
